"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _apis = require("../../@apis");
var _functions = require("../../@functions");
var _SimpleButton = _interopRequireDefault(require("../../@custom/SimpleButton"));
var _Input = _interopRequireDefault(require("../Input"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * @param {{
 *     user: any;
 *     onCancel?: () => void;
 *     onCodeValidated?: () => void;
 *     onCodeInvalidated?: () => void;
 * }} params
 */
function Code2faValidation(_ref) {
  var user = _ref.user,
    _ref$onCancel = _ref.onCancel,
    onCancel = _ref$onCancel === void 0 ? function () {} : _ref$onCancel,
    _ref$onCodeInvalidate = _ref.onCodeInvalidated,
    onCodeInvalidated = _ref$onCodeInvalidate === void 0 ? function () {} : _ref$onCodeInvalidate,
    _ref$onCodeValidated = _ref.onCodeValidated,
    onCodeValidated = _ref$onCodeValidated === void 0 ? function () {} : _ref$onCodeValidated;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    codeSent = _useState4[0],
    setCodeSent = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    inputCode = _useState6[0],
    setInputCode = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    wrongCode = _useState8[0],
    setWrongCode = _useState8[1];
  var canVerifyCode = (0, _react.useMemo)(function () {
    return !!(inputCode && codeSent);
  }, [inputCode, codeSent]);

  /** @param {React.ChangeEvent<HTMLInputElement>} evt */
  var handleInputCodeChange = function handleInputCodeChange(evt) {
    var value = (0, _functions.onlyNumbers)(evt.target.value);
    setInputCode(value);
  };
  var handleVerify2faCode = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var response;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            setWrongCode(false);
            _context.prev = 2;
            _context.next = 5;
            return _apis.appcenterApi.auth.twoFa.verifyCode(user, inputCode);
          case 5:
            response = _context.sent;
            if (response.data === 'invalid-code') {
              setWrongCode(true);
              onCodeInvalidated();
            } else {
              onCodeValidated();
            }
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);
            console.error('Error', _context.t0);
          case 12:
            _context.prev = 12;
            setLoading(false);
            return _context.finish(12);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 9, 12, 15]]);
    }));
    return function handleVerify2faCode() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleSend2faCode = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setLoading(true);
            _context2.prev = 1;
            _context2.next = 4;
            return _apis.appcenterApi.auth.twoFa.generateCode(user).then(function (resp) {
              return resp.data;
            });
          case 4:
            setCodeSent(true);
            _context2.next = 10;
            break;
          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](1);
            console.error('Error', _context2.t0);
          case 10:
            _context2.prev = 10;
            setLoading(false);
            return _context2.finish(10);
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 7, 10, 13]]);
    }));
    return function handleSend2faCode() {
      return _ref3.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          handleSend2faCode();
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  })), [user]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _stylesModule["default"].Code2faValidation
  }, !loading ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "Um c\xF3digo foi enviado ao seu telefone +", user.phoneCountry, " (", user.phoneArea, ") ", user.phone), /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    label: "C\xF3digo de verifica\xE7\xE3o",
    onChange: handleInputCodeChange,
    value: inputCode
  }), wrongCode && /*#__PURE__*/_react["default"].createElement("p", {
    className: _stylesModule["default"].Code2faValidationError
  }, "* C\xF3digo inv\xE1lido"), /*#__PURE__*/_react["default"].createElement("footer", {
    className: _stylesModule["default"].Code2faValidationFooter
  }, /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    variant: "cancel",
    onClick: onCancel
  }, "Cancelar"), codeSent && /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    variant: "info",
    onClick: handleSend2faCode
  }, "Enviar novamente"), /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    variant: "success",
    onClick: handleVerify2faCode,
    disabled: !canVerifyCode
  }, "Verificar"))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: _stylesModule["default"].Code2faValidationSpinnerContainer
  }, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null)));
}
var _default = Code2faValidation;
exports["default"] = _default;